export default __webpack_public_path__ + "static/media/dap-dark-text.958542cd.webp";